"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const styles_1 = require("./styles");
const Autocomplete = props => {
    const { items, top, left, selectedIndex, onClick } = props;
    if (!items.length) {
        return null;
    }
    const classes = (0, styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { className: classes.container, style: {
            top,
            left,
        }, children: (0, jsx_runtime_1.jsx)(material_1.List, { dense: true, children: items.map((item, index) => ((0, jsx_runtime_1.jsx)(material_1.ListItem, { className: classes.item, selected: index === selectedIndex, onClick: () => onClick(index), children: item.content }, index))) }) }));
};
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=index.js.map